import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/medconsult_pro/src/app/homepage/components/HomepageInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/medconsult_pro/src/components/common/Header.tsx");
